module.exports = __webpack_public_path__ + "static/media/IMG_20180203_100130.220df282.jpg";